// First-touch marketing attribution.
//
// On load, writes a write-once, cross-subdomain cookie `obq_attr` on
// `.openbooq.com` so that `portal.openbooq.com` can read the original
// acquisition context at signup. This is part 1 of a 3-repo passthrough
// (website -> portal -> backend) and has no functional effect on this site.
//
// The cookie is only written if it is not already present, preserving the
// genuine first-touch. Dependency-free and wrapped in try/catch so it can
// never break page load.
//
// KEEP IN SYNC with the inline copy in scripts/geo/lib.mjs (static GEO pages)
// and openbooq-frontend lib/first-touch.ts (portal write side).
(function captureFirstTouch() {
  try {
    // Already captured -> preserve the original first-touch, do nothing.
    if (document.cookie.indexOf("obq_attr=") !== -1) return;

    var params = new URLSearchParams(window.location.search);
    var attr = {};

    [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "gclid",
      "gbraid",
      "wbraid",
      "gad_source",
      "fbclid",
      "ttclid",
      "msclkid",
    ].forEach(function (key) {
      var value = params.get(key);
      if (value) attr[key] = value;
    });

    // Referral-program redemption rail: share links land as ?ref=<code> (the
    // canonical form) or /r/<code> (the pretty share path, which the SPA
    // redirects to /?ref=<code> AFTER this script has already run — so the
    // path form must be read here, at the true first touch). Stored under
    // `referralCode` — the exact field name the backend expects on both
    // POST /v1/users/me (AttributionDto) and POST /v1/leads (CreateLeadDto).
    // Charset-locked to the backend's code alphabet: a malformed referralCode
    // would 400 the WHOLE lead payload via class-validator.
    var ref = params.get("ref");
    if (!ref) {
      var refPath = window.location.pathname.match(/^\/r\/([^/]+)\/?$/);
      if (refPath) {
        // Guarded decode: a malformed %-sequence must not abort the whole
        // capture (the charset test below rejects junk either way).
        try {
          ref = decodeURIComponent(refPath[1]);
        } catch (e2) {
          ref = refPath[1];
        }
      }
    }
    if (ref) {
      ref = ref.trim();
      if (/^[A-Za-z0-9_-]{1,64}$/.test(ref)) attr.referralCode = ref;
    }

    if (document.referrer) attr.referrer = document.referrer;

    attr.landing = window.location.pathname + window.location.search;
    attr.ts = new Date().toISOString();

    var value = encodeURIComponent(JSON.stringify(attr));
    document.cookie =
      "obq_attr=" +
      value +
      "; domain=.openbooq.com; path=/; max-age=7776000; SameSite=Lax; Secure";
  } catch (e) {
    // Never let attribution capture break the page.
  }
})();
